export enum EnsEventsEnum {
  TRANSFER = 'EVENTS.TRANSFER',
  REGISTRATION = 'EVENTS.REGISTRATION',
  RENEWAL = 'EVENTS.RENEWAL',
  SALE = 'EVENTS.SALE',
  MINT = 'EVENTS.MINT',
  BURN = 'EVENTS.BURN',
}

export enum EnsEvensSymbolEnum {
  'EVENTS.TRANSFER' = 'sync_alt',
  'EVENTS.REGISTRATION' = 'sync_alt',
  'EVENTS.RENEWAL' = 'update',
  'EVENTS.SALE' = 'shopping_cart',
  'EVENTS.MINT' = 'magic_button',
  'EVENTS.BURN' = 'local_fire_department',
}
